<template>
	<div class="container">
		<div class="handle-container">
			<Tabs v-model="apiTab" style="width: 100%;">
				<TabPane label="调用接口" name="callApi">
					<div class="table-container">
						<Table :columns="callApiColumns" :data="callApis">
							<template slot-scope="{ row }" slot="action">
								<span class="edit-style" @click='handleEdit(row)'>编辑</span>
								<Poptip confirm title="确认要删除这条数据吗？" @on-ok="delRating(row.id)" transfer>
									<span class="del-style">删除</span>
								</Poptip>
							</template>
						</Table>
					</div>
				</TabPane>
				<TabPane label="接收接口" name="receiveApi" v-if="[974, 4679, 109598, 106997, 107938, 107932, 107949, 107964, 112260].includes(company.id)">
					<div class="table-container">
						<Table :columns="receiveApiColumns" :data="receiveApis">
							<template slot-scope="{ row }" slot="action">
								<span class="edit-style" @click='receiveApiEdit(row)'>编辑</span>
								<Poptip confirm title="确认要删除这条数据吗？" @on-ok="delRating(row.id)" transfer>
									<span class="del-style">删除</span>
								</Poptip>
							</template>
						</Table>
					</div>
				</TabPane>
				<Button v-if="apiTab === 'callApi'" type="primary" icon="md-add" @click="openModal" slot="extra" size="small">调用接口</Button>
				<Button v-if="apiTab === 'receiveApi'" type="primary" icon="md-add" @click="openReceiveModal" slot="extra" size="small">接收接口</Button>
			</Tabs>
		</div>

		<ApiSettingsModal v-model="showApiSettingModal" @onSubmit="editApiSetting" @onCancel="closeModal"
			:currApiSetting="currApiSetting" />

		<ReceiveApiModal v-model="showReveiveApiModal" @onSubmit="editApiSetting" @onCancel="closeReceiveModal"
			:currApiSetting="currReceiveApiSetting" />
	</div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import ApiSettingsModal from './ApiSettingsModal.vue'
import { addNodeId } from '@/utils/nodeIdPool';
import ReceiveApiModal from './ReceiveApiModal.vue';

export default {
	components: {
		ApiSettingsModal,
		ReceiveApiModal,
	},
	data() {
		return {
			showApiSettingModal: false,
			showReveiveApiModal: false,
			currApiSetting: undefined,
			currReceiveApiSetting: undefined,
			callApiColumns: [
				{ title: '名称', key: 'name' },
				{ title: '方法', key: 'method' },
				{ title: '接口地址', key: 'url' },
				{ title: '接口内容', key: 'content' },
				{ title: '内容类型', key: 'content_type' },
				{
					title: '配置变量',
					key: 'param',
					width: 300,
					render: (h, params) => {
						const paramList = params.row.param || [];
						if (!paramList || paramList.length === 0) {
							return h('span', {
								style: {
									color: '#999',
									fontSize: '13px'
								}
							}, '暂无配置');
						}
						return h('div', {
							style: {
								maxHeight: '100px',
								overflowY: 'auto'
							}
						}, paramList.map((item, index) => {
							return h('div', {
								style: {
									padding: '4px 8px',
									fontSize: '12px'
								}
							}, [
								h('div', {
									style: {
										fontWeight: '500',
										color: '#333',
										marginBottom: '2px'
									}
								}, `名称: ${item.name || '-'}`),
								h('div', {
									style: {
										color: '#666',
										fontSize: '11px'
									}
								}, `参数: ${item.key || '-'}  |  变量: ${item.vars || '-'}`)
							]);
						}));
					}
				},
				{ title: '操作', slot: 'action' },
			],
			receiveApiColumns: [
				{ title: '名称', key: 'name' },
				{ title: '方法', key: 'method' },
				{ title: '接口地址', key: 'url' },
				{ title: '获取参数', key: 'content' },
				{
					title: '消息动作',
					key: 'action',
					width: 300,
					render: (h, params) => {
						const actions = params.row.action || [];
						if (!actions || actions.length === 0) {
							return h('span', {
								style: {
									color: '#999',
									fontSize: '13px'
								}
							}, '暂无配置');
						}
						return h('div', {
							style: {
								maxHeight: '100px',
								overflowY: 'auto'
							}
						}, actions.map((item, index) => {
							return h('div', {
								style: {
									padding: '4px 8px',
									fontSize: '12px'
								}
							}, [
								h('div', {
									style: {
										fontSize: '12px'
									}
								}, `消息${index + 1}: ${item.name || '-'} = ${item.key || '-'}`),
								h('div', {
									style: {
										color: '#666',
										fontSize: '11px'
									}
								}, `动作: 跳转节点 = ${this.getSceneNameAndNodeName(item.scene, item.node)}`)
							]);
						}));
					}
				},
				{ title: '操作', slot: 'action' },
			],
			apiTab: 'callApi'
		}
	},
	computed: {
		...mapState('setting', [
			'apiSettings',
		]),
    ...mapState('flow', [
			'flows'
    ]),
    ...mapState('user', ['company']),
		callApis() {
			const keys = Object.keys(this.apiSettings || {});
			return keys.map(key => {
				const apiSetting = this.apiSettings[key];
				return {
					...apiSetting,
					id: key,
				}
			}).filter(item => !item.type)
		},
		receiveApis() {
			const keys = Object.keys(this.apiSettings || {});
			return keys.map(key => {
				const apiSetting = this.apiSettings[key];
				return {
					...apiSetting,
					id: key,
				}
			}).filter(item => item.type === 1)
		},
	},
	methods: {
		...mapActions('setting', ['updateApiSettings']),
		openModal() {
			this.showApiSettingModal = true;
		},
		openReceiveModal() {
			this.showReveiveApiModal = true;
		},
		editApiSetting({ id, name, url, content, method, content_type, ...otherParams }) {
			const newApiSetting = { ...this.apiSettings };
			if (id) {
				delete newApiSetting[id]
			} else {
				id = addNodeId('S')
			}
			this.updateApiSettings({ ...newApiSetting, [id]: { content_type: content_type || 'application/json', id, name, url, content, method: method || 'POST', ...otherParams } })
		},
		delRating(id) {
			const newApiSetting = { ...this.apiSettings };
			if (id) {
				delete newApiSetting[id]
			}
			this.updateApiSettings(newApiSetting)
		},
		handleEdit(ratingInfo) {
			this.currApiSetting = { ...ratingInfo };
			this.openModal();
		},
		receiveApiEdit(ratingInfo) {
			this.currReceiveApiSetting = { ...ratingInfo };
			this.openReceiveModal();
		},
		closeModal() {
			this.currApiSetting = undefined;
		},
		closeReceiveModal() {
			this.currReceiveApiSetting = undefined;
		},
		// 根据场景id和节点id获取场景名和节点名
		getSceneNameAndNodeName(sceneId, nodeId) {
			const scene = this.flows?.find(item => item.id === sceneId);
			const node = scene?.nodes?.find(item => item.id === nodeId);
			if (!scene || !node) {
				return '-'
			}
			return `${scene.name} - ${node.name}}`
		},
	}
}
</script>
<style lang="scss" scoped>
.container {
	width: 100%;
	padding: 20px;
	background-color: #fff;

	.handle-container {
		width: calc(100vw - 120px);
		display: flex;
		justify-content: space-between;

		.btn-style {
			display: flex;
			justify-items: flex-start;

			div {
				padding: 10px 20px;
				border-radius: 20px;
				font-size: 14px;
				color: #fff;
			}

			.add-style {
				background-color: #ffa800;
				margin-right: 10px;
			}

			.export-style {
				background-color: #6186cf;
			}

			i {
				font-size: 18px;
			}
		}
	}

	.table-container {
		padding: 20px 0;
	}

	.del-style {
		color: #e72e2e;

	}

	.edit-style {
		display: inline-block;
		color: #6186cf;
		padding-right: 20px;
	}
}
</style>